import React, { useEffect, useRef } from 'react';
import './InformationPopup.scss';
import Icons from '../../assets/icons';
import Modal from '../Modal/Modal';
// import { useTranslation } from 'react-i18next';

interface IProps {
  attractionName?: string;
  attractionNameCategory?: string;
  attractionDescription?: string;
  attractionFullDescription?: string;
  attractionCategoryDescription?: string;
  isVisibleInfoPopup: boolean;
  handleClose: () => void;
}

const InformationPopup = (props: IProps) => {
  const {
    attractionName,
    attractionNameCategory,
    attractionDescription,
    attractionFullDescription,
    attractionCategoryDescription,
    isVisibleInfoPopup,
    handleClose,
  } = props;
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        handleClose();
      }
    };

    if (isVisibleInfoPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisibleInfoPopup, handleClose]);

  const handleCloseButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    handleClose();
  };

  if (!isVisibleInfoPopup) {
    return null;
  }

  return (
    <Modal
      open={isVisibleInfoPopup}
      onClose={handleClose}
      ariaLabel="Szczegóły atrakcji"
    >
      <div className="berg-information-popup-background" />
      <div
        ref={popupRef}
        className="berg-information-popup flex flex-col gap-3 justify-center"
      >
        {attractionFullDescription && (
          <div className="flex flex-row justify-between mt-48 sm:mt-0">
            <h3>{attractionName}</h3>

            <button onClick={handleCloseButtonClick}>
              <Icons.ClosePopup />
            </button>
          </div>
        )}
        {attractionDescription && <p>{attractionDescription}</p>}
        {attractionNameCategory && (
          <div className="flex flex-row justify-between ">
            <h3>{attractionNameCategory}</h3>
            <button onClick={handleCloseButtonClick}>
              <Icons.ClosePopup />
            </button>
          </div>
        )}
        {attractionFullDescription && (
          <div
            className="flex flex-col gap-5 text-start mb-5 sm:mb-0"
            dangerouslySetInnerHTML={{ __html: attractionFullDescription }}
          ></div>
        )}
        {attractionCategoryDescription && (
          <div
            className="flex flex-col gap-5 text-start"
            dangerouslySetInnerHTML={{ __html: attractionCategoryDescription }}
          ></div>
        )}
      </div>
    </Modal>
  );
};

export default InformationPopup;
